import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { MUTATION_KEY } from './keys';
import { clmUserApiClient } from '../clients';
import type {
  ApiErrorResponse,
  PatientCreateRequest,
  PatientCreateResponse,
} from '../types';
import { isApiErrorResponse } from '../utils';

const patientUpdateMutation = async (
  data: PatientCreateRequest,
): Promise<PatientCreateResponse> => {
  const response = await clmUserApiClient.put<
    PatientCreateResponse,
    ApiErrorResponse
  >(`patient/${data.patient.id}`, data);

  if (!response.data) {
    throw new Error('No data returned from update patient');
  }

  if (!response.ok) {
    if (isApiErrorResponse(response.data)) {
      throw new Error(response.data.details);
    }
    throw new Error('Unknown error');
  }

  return response.data;
};

export const usePatientUpdateMutation = (
  config?: Omit<
    UseMutationOptions<PatientCreateResponse, Error, PatientCreateRequest>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation({
    mutationKey: [MUTATION_KEY.PATIENT_UPDATE],
    mutationFn: patientUpdateMutation,
    ...config,
  });
